import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "assets/shared/Logo.png";
type IStudentsTemplate = {
  children: React.ReactNode;
};

export default function BaseTemplate({ children }: IStudentsTemplate) {
  const navigate = useNavigate();

  https: return (
    <div className="student-container flex  justify-center items-center  ">
      <header className="header absolute left-5 top-5">
        <img
          onClick={() => window.open("https://heroicgameday.in/")}
          src={logo}
          alt="Heroic Game Day"
          className="logo img-fluid cursor-pointer"
        />
      </header>
      <div className="btn-americau a btn-learn absolute left-5 bottom-5">
        <a
          onClick={() =>
            window.open("https://heroicgameday.in/privacy-policy/", "_blank")
          }
          type="button"
          className="learn-more-btn relative right-0"
        >
          Policies
        </a>
      </div>
      {children}
    </div>
  );
}
